export default {

    setGroups(state, groups) {
        state.groups = groups;
    },

    setActiveGroup(state, activeGroup) {
        state.activeGroup = activeGroup;
    },
}